import { render, staticRenderFns } from "./ucusraporu.vue?vue&type=template&id=4e6ac392&"
import script from "./ucusraporu.vue?vue&type=script&lang=js&"
export * from "./ucusraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports